export const GET_CAMPAIGNS_QUERY = `
  query CampaignFindMany($filter: FilterFindManyCampaignInput, $limit: Int) {
    CampaignFindMany(filter: $filter, limit: $limit) {
      _id
      name
      nickname
      status
      consecutive_in_traffic_source
      remoteCampaign
      trafficSource {
        _id
        name
        shortname
        logo
        nickname
        api {
          name
        }
      }
      targetROI
    }
  }
`;

export const fetchCampaigns = async (filter: any, limit = 50) => {
  const { API_V2 } = await import('@/src/lib/axios');
  
  const { data: result } = await API_V2.post('graphql', {
    query: GET_CAMPAIGNS_QUERY,
    variables: { filter, limit },
  });

  if (result.errors) {
    throw result.errors[0];
  }
  
  return result.data?.CampaignFindMany || [];
};
